import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useCustomers} from '../hooks/useCustomers.ts';
import {useCustomersSelection} from '../hooks/useCustomersSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';
import {ArchiveRecordButton} from '../buttons/ArchiveRecordButton.tsx';
import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {Customer} from '../types';
import {I18n} from "@aws-amplify/core";

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useCustomersSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchMoreRecords,
        handleFilterByKeyword
    } = useCustomers();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {columns: baseColumns} = useTableColumns();

    const columns: DataTableColumn<Customer>[] = [
        ...baseColumns,
        {
            accessor: 'actions',
            title: I18n.get('Actions'),
            textAlign: 'center',
            render: (record: Customer) => (
                <ArchiveRecordButton customer={record}/>
            ),
        },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchMoreRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchMoreRecords}/>
        </SimpleGrid>
    );
};
